import "../css/quote.css";

function Quote(props) {
  return <div className="wrapper-quote"><p>{props.content}</p></div>;
}

export default Quote;
